import React from 'react'
import './LegacyCreditUserCard.css'

const LegacyCreditUserCard = ({ name, email, legacyCreditsAmount, paidAmount, status }) => {
  return (
    <div className='legacy-credit-container'>

      <div>
        <h4>{name}</h4>
        <div className='legacy-credit-details'>
            <p>Email: {email}</p>
            <p>Legacy Credits: {legacyCreditsAmount}</p>
            <p>Legacy Price: KES{paidAmount.toFixed(2)}</p>
        </div>
      </div>

      <div>
        <p className='legacy-credit-status'>{status}</p>
      </div>

    </div>
  )
}

export default LegacyCreditUserCard